// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1dQqT","label":"styles_label__21GDN"};